import { Box, Flex } from '@chakra-ui/react';
import { BiArrowToTop, BiArrowToBottom } from 'react-icons/bi';
import { RiArrowDownSLine, RiArrowUpSLine } from 'react-icons/ri';
import { IconType } from 'react-icons';
import {
  ActionButton,
  ActionButtonGroup,
  Background,
  ScrollThumb,
  Section,
} from './ScrollbarAtoms';
import { DataDirection } from '../../../../core/types/ui/position';
import useRowScrollbar, {
  RowScrollbarProps,
} from '../../../hooks/useRowScrollbar';
import { GridEntity } from '../../../types';

const RowScrollbar: React.FC<RowScrollbarProps> = (props) => {
  const { stroke, freezedRows, startSingleScroll, jumpScrollToStartEnd } =
    props;

  const {
    scrollbarWidth,
    buttonSize,
    scrollBarHeight,
    scrollThumbHeight,
    topSectionHeight,
    bottomSectionHeight,
    frozenAreaHeight,
    scrollAreaHeight,

    thumbPosition,
    thumbRef,
    onThumbMouseDown,
  } = useRowScrollbar(props);

  const scrollArea = () => {
    // const scrollAreaHeight =
    //   scrollBarHeight -
    //   topSectionHeight -
    //   bottomSectionHeight -
    //   frozenAreaHeight;
    return (
      <Box
        height={`${scrollAreaHeight}px`}
        position="relative"
        width="100%"
        overflow="hidden"
        as={Flex}
        alignItems="center"
        flexDirection="column"
      >
        <ScrollThumb
          background={stroke}
          styleProps={{
            top: `${thumbPosition}px`,
            width: '80%',
            height: `${scrollThumbHeight}px`,
          }}
          thumbRef={thumbRef}
          // hoverStyle={{
          //   width: '85%',
          // }}
          onThumbMouseDown={onThumbMouseDown}
        />
      </Box>
    );
  };

  const frozenAreaView = () => (
    <Box
      height={`${frozenAreaHeight}px`}
      position="relative"
      width="100%"
      background={stroke}
      opacity={0.2}
    />
  );

  const actionButtonView = (
    Icon: IconType,
    direction: DataDirection,
    isSingleJump: boolean
    // onMouseDown?: ScrollButtonInteraction,
    // onClick?: ScrollButtonInteraction
  ) => (
    <ActionButton
      background={stroke}
      buttonProps={{
        width: '100%',
        height: `${buttonSize}px`,
      }}
      Icon={Icon}
      onMouseDown={isSingleJump ? startSingleScroll : undefined}
      onClick={!isSingleJump ? jumpScrollToStartEnd : undefined}
      entityType={GridEntity.Row}
      direction={direction}
    />
  );

  const buttonGroup = (height: number, isSingleJump = false) => {
    return (
      <Section
        sectionProps={{
          height: `${height}px`,
          flexDirection: 'column',
          width: '100%',
        }}
      >
        <ActionButtonGroup
          stroke={stroke}
          buttonGroupProps={{
            height: `${buttonSize * 2}px`,
            width: '100%',
            borderWidth: '1px 0px',
            flexDirection: 'column',
          }}
        >
          {actionButtonView(
            isSingleJump ? RiArrowUpSLine : BiArrowToTop,
            DataDirection.Backward,
            isSingleJump
          )}
          {actionButtonView(
            isSingleJump ? RiArrowDownSLine : BiArrowToBottom,
            DataDirection.Forward,
            isSingleJump
          )}
        </ActionButtonGroup>
      </Section>
    );
  };

  return (
    <Background
      stroke={stroke}
      boxProps={{
        top: '0px',
        right: `-${scrollbarWidth}px`,
        height: `${scrollBarHeight}px`,
        width: `${scrollbarWidth}px`,
        borderWidth: '0px 1px',
        flexDirection: 'column',
      }}
    >
      {buttonGroup(topSectionHeight)}
      {freezedRows.frozen && frozenAreaView()}
      {scrollArea()}
      {buttonGroup(bottomSectionHeight, true)}
    </Background>
  );
};

export default RowScrollbar;
